module.exports = __webpack_public_path__ + "static/media/brandmark-design.1831092f.png";